import { chunkArray } from '../../utils/arrays';
import { ID_CHUNK_SIZE } from './policy';

export function uniqueChunks<T>(values: T[]): T[][] {
  return chunkArray([...new Set(values)], ID_CHUNK_SIZE);
}

export function uniqueBy<T>(values: T[], key: (value: T) => string): T[] {
  const seen = new Set<string>();

  return values.filter(value => {
    const valueKey = key(value);
    if (seen.has(valueKey)) return false;
    seen.add(valueKey);
    return true;
  });
}
